// ======================================================================
// File Name       : SelectContentLinkCourseDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import { Modal, Col, Button } from 'react-bootstrap';
import { MODAL_SIZE } from '../../../constants/index';
import * as csvDownloadAction from '../../../actions/csvDownloadAction';
import RenderField from '../../../utils/ReduxFormUtils';
import ModalWrapper from '../../../components/modal/ModalWrapper';
import ContentLinkCourseSearch from './ContentLinkCourseSearch';
import ContentLinkCourseList from './ContentLinkCourseList';
import ContentLinkCourseSelectedList from './ContentLinkCourseSelectedList';
import MessageSearch from '../../../components/MessageSearch';
import { CONTENT_TYPE } from '../../../constants/CSVDownloadConstant';


class SelectContentLinkCourseDialog extends Component {
  constructor(props) {
    super();
    this.state = {
      checkedContentList: [],
      checkedContentOnModal: [],
      isAllowShowSearchMessage: false,
    };
    this.onOK = this.onOK.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleCheckAllBox = this.handleCheckAllBox.bind(this);
    this.handleRemoveAll = this.handleRemoveAll.bind(this);
    this.handleRemoveContent = this.handleRemoveContent.bind(this);
    this.handleAddContent = this.handleAddContent.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(csvDownloadAction.initTargetContent());
  }

  componentWillUnmount() {
    this.props.dispatch(csvDownloadAction.unMountContentDialog());
  }

  /* Handle OK button */
  onOK() {
    const { addedContentList } = this.props;
    this.props.dispatch(csvDownloadAction.addCheckedContentToTargetList(addedContentList));
    this.props.hideModal();
  }

  /* Handle 戻る button */
  onCancel() {
    this.props.dispatch(csvDownloadAction.resetContent());
    this.props.hideModal();
  }

  /* Handle paging event */
  getStartEndData(startPosition) {
    const { invalid, formValues, contentSearchConditions } = this.props;
    if (invalid) return;
    if (contentSearchConditions && Object.keys(contentSearchConditions).length > 0) {
      const param = contentSearchConditions;
      this.props.dispatch(csvDownloadAction.searchContent(param, startPosition));
    } else {
      this.props.dispatch(csvDownloadAction.initTargetContent(startPosition));
    }
  }

  /* Handle Checkbox event */
  handleCheckbox(event) {
    const { value } = event.target;

    const checkedContentOnModal = [...this.state.checkedContentOnModal];

    const position = checkedContentOnModal.indexOf(value);
    position < 0 ? checkedContentOnModal.unshift(value) : checkedContentOnModal.splice(position, 1);

    this.setState({ checkedContentOnModal });
  }

  /* Handle add content */
  handleAddContent() {
    const checkedContentOnModal = [...this.state.checkedContentOnModal];
    const checkedContentList = [...this.state.checkedContentOnModal];
    this.setState({ checkedContentOnModal }, () => {
      this.props.dispatch(
        csvDownloadAction.addCheckedContentToAddedList({ addedList: this.state.checkedContentOnModal }));
    });
  }

  /* Handle remove item */
  handleRemoveContent(itemSecernId) {
    const { checkedContentList, checkedContentOnModal } = this.state;
    const pos = checkedContentList.indexOf(itemSecernId);
    if (pos >= 0) {
      checkedContentList.splice(pos, 1);
    }
    const pos2 = checkedContentOnModal.indexOf(itemSecernId);
    if (pos2 >= 0) {
      checkedContentOnModal.splice(pos2, 1);
    }
    this.setState({
      checkedContentList, checkedContentOnModal,
    }, () => {
      this.props.dispatch(csvDownloadAction.addCheckedContentToAddedList({ removedSecern: itemSecernId }));
    });
  }

  /* Handle check all */
  handleCheckAllBox() {
    const { targetContent, csvDownload, formValues } = this.props;
    const { checkedContentList, checkedContentOnModal } = this.state;

    const checkContentIdChecked = [];
    if (targetContent.allSecernIds && targetContent.allSecernIds.length) {
      targetContent.allSecernIds.map((itemSecernId) => {
        const pos = checkedContentOnModal.indexOf(itemSecernId);
        if (pos > -1) {
          checkContentIdChecked.push(pos);
        }
      });

      if (checkContentIdChecked.length === targetContent.allSecernIds.length) {
        // uncheck all
        targetContent.allSecernIds.map((itemSecernId) => {
          const pos = checkedContentOnModal.indexOf(itemSecernId);
          if (pos > -1) {
            checkedContentOnModal.splice(pos, 1);
          }
          return null;
        });
        this.setState({ checkedContentOnModal: [...checkedContentOnModal],
          checkedContentList: [...checkedContentOnModal] });
        return;
      }
      // checkAll
      targetContent.allSecernIds.map((itemSecernId) => {
        if (checkedContentList.indexOf(itemSecernId) < 0) {
          checkedContentList.unshift(itemSecernId);
        }
        return null;
      });
      this.setState({ checkedContentOnModal: [...checkedContentList],
        checkedContentList });
    }
  }

  /* Remove all added contents */
  handleRemoveAll() {
    this.setState({
      checkedContentList: [],
      checkedContentOnModal: [],
    }, () => {
      this.props.dispatch(csvDownloadAction.addCheckedContentToAddedList({ removedAll: true }));
    });
  }

  /* Handle Search on Dialog */
  handleSearch() {
    const { formValues } = this.props;
    const { contentName, boxName, contentType,
      courseName, userAttributeKeyNum, userAttributeSearchText } = formValues;
    let { contentTypeRadio } = formValues;
    if (contentTypeRadio === CONTENT_TYPE.NO_SELECTION) {
      contentTypeRadio = null;
    } else if (contentTypeRadio === CONTENT_TYPE.EXTERNAL_CONTENT) {
      contentTypeRadio = 1;
    } else if (contentTypeRadio === CONTENT_TYPE.SERVICE_CONTENT) {
      contentTypeRadio = 0;
    }
    const params = {
      contentName,
      boxName,
      contentType,
      contentTypeRadio,
      courseName,
      userAttributeKeyNum,
      userAttributeSearchText,
    };
    this.props.dispatch(csvDownloadAction.searchContent(params));
    this.props.change('startPosition', 0);
    this.setState({ isAllowShowSearchMessage: true });
  }

  /* Turn off message */
  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  /* Config header and footer modal */
  getModalOptions() {
    return {
      title: '対象となるコンテンツを指定してください',
      footerBtns: null,
    };
  }

  render() {
    const { video, drill, document, link, targetContent } = this.props;
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };

    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
      >
        <MessageSearch
          recordNum={targetContent ? targetContent.recordNum : 0}
          resultList={targetContent ? targetContent.allSecernIds : []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />

        <ContentLinkCourseSearch
          handleSearch={this.handleSearch}
        />

        <ContentLinkCourseList
          getStartEndData={this.getStartEndData}
          checkedContentOnModal={this.state.checkedContentOnModal}
          handleCheckbox={this.handleCheckbox}
          handleCheckAllBox={this.handleCheckAllBox}
          handleAddContent={this.handleAddContent}
        />

        <ContentLinkCourseSelectedList
          handleRemoveContent={this.handleRemoveContent}
          handleRemoveAll={this.handleRemoveAll}
          onCancel={this.onCancel}
          onOK={this.onOK}
        />

      </ModalWrapper>

    );
  }
}


const mapStateToProps = (state, ownProps) => {
  const formValues = getFormValues('selectTargetContentDialog')(state);
  const { csvDownload } = state;
  const { targetContent, addedContentList, contentSearchConditions } = csvDownload;
  return {
    formValues,
    csvDownload,
    targetContent,
    addedContentList,
    initialValues: {
      startPosition: 0,
      userAttributeKeyNum: 1,
      contentTypeRadio: '0',
    },
    contentSearchConditions,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'selectTargetContentDialog', // a unique identifier for this form
  touchOnChange: true,
})(SelectContentLinkCourseDialog));

